// ATTENTION: 合并了原来业务侧和 saas-editor 里面的两个文件
import React, { useLayoutEffect } from 'react';

// 计时器
// let timer: number = 0;

// 前缀
const PREFIX = 'data-track-';

export const useListTrack = (targetId: string, list: any[] = [], cb: (data: any) => void) => {
    useLayoutEffect(() => {
        // 清除计时器
        // timer && clearTimeout(timer)
        // NOTE 延时发送是因为瀑布流滚动在监听了list变化后再次重新计算两边的高度后再进行最后的DOM渲染
        // 所以如果不延时发送的话，第一次无法获取到DOM
        window.setTimeout(() => {
            try {
                // 避免空数组多上报一次
                if (!list.length) return;
                const el = document.getElementById(targetId) as HTMLDivElement;
                if (!el) return;

                const items = el.querySelectorAll("[data-type='track']");
                // NOTE IntersectionObserver 该api目前存在兼容性，其中Safari支持12.1及其以上版本
                // 在sentry收集到的错误日志中发现目前有23个用户使用的是Safari 11.x版本
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((item) => {
                            // 新的数据有可能会有旧的节点，先把上报过的标记清除掉
                            const attrs = item.target.getAttributeNames().filter((v) => v.indexOf(PREFIX) !== -1);
                            if (item.isIntersecting) {
                                const isTrack = item.target.getAttribute('data-track');
                                if (!isTrack) {
                                    // 回吐数据
                                    const data: { [key: string]: any } = {};
                                    attrs.forEach((v) => {
                                        const value = item.target.getAttribute(v);
                                        const key = v.replace(PREFIX, '');
                                        data[key] = value;
                                    });
                                    item.target.setAttribute('data-track', 'true');
                                    cb && Object.keys(data).length && cb(data);
                                    observer.unobserve(item.target);
                                }
                            }
                        });
                    },
                    {
                        rootMargin: '0px',
                        threshold: 0.5,
                    },
                );
                items.forEach((item: any) => {
                    // 内置素材不需要上报
                    const isPreset = item.getAttribute('data-preset') === '1';
                    if (!isPreset) {
                        observer.observe(item);
                    }
                });
            } catch (e) {
                //
            }
        }, 0);
    }, [list]);
};

export default useListTrack;
